import React from "react";

function EvolucaoMigracao() {
    const evolucaoItems = [
        {
            id: 1,
            imgSrc: "../assets/evolucao1.png",
            alt: "Economizamos recursos",
            text: "Economizamos recursos"
        },
        {
            id: 2,
            imgSrc: "../assets/evolucao2.png",
            alt: "Otimizamos seu tempo",
            text: "Otimizamos seu tempo"
        },
        {
            id: 3,
            imgSrc: "../assets/evolucao3.png",
            alt: "Projetamos seu desempenho",
            text: "Projetamos seu desempenho"
        }
    ];

    return (
        <div
            className="w-full p-24 flex flex-col items-center justify-center"
            style={{
                backgroundImage: "url('../assets/cover-proposito.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center justify-center w-full">
                    {evolucaoItems.map((item, index) => (
                        <React.Fragment key={item.id}>
                            {/* Image and text */}
                            <div className="flex flex-col items-center justify-center md:w-1/3">
                                <div className="mb-6 flex justify-center">
                                    <img
                                        src={item.imgSrc}
                                        alt={item.alt}
                                    />
                                </div>
                                <p className="text-white text-center font-inter-regular text-xl">
                                    {item.text}
                                </p>
                            </div>

                            {/* Vertical divider - only show between items, not after the last one */}
                            {index < evolucaoItems.length - 1 && (
                                <div className={`hidden md:block h-32 w-[1px] bg-blue-400 ${index === 1 ? '-ml-12 mr-12' : '-mr-10'}`}></div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default EvolucaoMigracao;
